import "../chunks/chunk.6M63UXML.js";
import "../translations/en.js";
import { LocalizeController as DefaultLocalizationController } from "@shoelace-style/localize";
class LocalizeController extends DefaultLocalizationController {
}
import { registerTranslation } from "@shoelace-style/localize";
export {
  LocalizeController,
  registerTranslation
};
